import { useTranslation } from 'react-i18next';

import { OnboardingStyle } from '../onboarding/onboarding-style';
import { AuthHeader, ContentLayout } from '../../../global-styles/layout';
import { Heading2Text } from '../../../components/typography/typography';
import { images } from '../../../assets/images/images';
import { ExpiredLinkStyles } from './expired-link-style';

const ExpiredLink = () => {
  const { t } = useTranslation(['common', 'expiredLink']);

  return (
    <ContentLayout data-cy="expired-link-page">
      <ExpiredLinkStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <Heading2Text as="h1" weight={600}>
                  {t('expiredLink:expired-title')}
                </Heading2Text>
              </div>
            </AuthHeader>
            <div className="expired-link-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
        </OnboardingStyle>
      </ExpiredLinkStyles>
    </ContentLayout>
  );
};

export default ExpiredLink;
